import { AuthorizedUser } from '../models/User';

type EventData = Record<string, unknown>;

const getProfileCompletionLevel = (user?: AuthorizedUser): number => {
  if (!user) {
    return 0;
  }

  const values = [
    user.details?.sexuality,
    user.details?.haircolor,
    user.details?.eyecolor,
    user.description,
  ];

  return values.reduce((total, value) => (value ? total + 1 : total), 0);
};

export const buildStandardUserData = (user?: AuthorizedUser) => {
  const emailStatus = user?.credentials?.emailStatus ?? 0;

  return {
    profileCompletionLevel: getProfileCompletionLevel(user),
    emailVerified: emailStatus > 0 ? 1 : 0,
    hasPaid: user?.credentials?.lastTransaction ? 1 : 0,
  };
};

export const logDataLayerEvent = (
  event: string,
  data: EventData = {},
  user?: AuthorizedUser
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
  }

  window.dataLayer.push({
    event,
    ...data,
    ...buildStandardUserData(user),
  });
};
